export * as affiliate from './affiliate'
export * as amount from './amount'
export * as fsFunction from './func-fs'
